<template>
  <div v-if="!isApplicant">
    <PreLoader v-if="meetingsAreLoading && !isNewMeeting" />
    <div v-if="meeting" class="Meeting-editor">
      <h1 class="Meeting-editor__header">
        {{ isNewMeeting ? "Nytt möte" : "Uppdatera möte" }}
      </h1>
      <div class="Grid--beta">
        <div class="Grid__col Grid__col--6">
          <div class="Meeting-editor__date-wrap">
            <label class="Form-input__label" for="title">Datum</label>
            <div class="Form-input">
              <DatePickerInput
                :value="parseDate(meeting.date)"
                element-id="date"
                placeholder="meeting date"
                type="date"
                @input="updateMeeting('date', $event)"
              />
            </div>
          </div>
        </div>
        <div class="Grid__col Grid__col--6">
          <div class="Meeting-editor__type-wrap">
            <label class="Form-input__label" for="type">Typ</label>
            <div class="Form-input">
              <DropdownInput
                :value="meeting.meetingType"
                element-id="meetingType"
                :options="meetingTypeOptions"
                @input="updateMeeting('meetingType', $event)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="Grid--beta">
      <div class="Grid__col Grid__col--6">
        <button
          class="Button Button--approve Button--large"
          @click="submitEditedMeeting"
        >
          Spara
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters, mapActions } from "vuex";
import { meetingTypes } from "@/utils/constants";
import { formatDate } from "@/utils/helpers";
import { parseObjectToOptions } from "@/utils/array-helpers";
import PreLoader from "@/components/PreLoader";
import DatePickerInput from "@/components/forms/DatePickerInput";
import DropdownInput from "@/components/forms/DropdownInput";
import moment from "moment";

export default {
  name: "MeetingRoute",
  components: {
    PreLoader,
    DatePickerInput,
    DropdownInput
  },
  created() {
    if (!this.isNewMeeting) this.getMeeting(this.$route.params.id);
  },
  destroyed() {
    this.$store.commit("meetingStore/resetMeeting");
  },
  computed: {
    ...mapState("meetingStore", ["meeting"]),
    ...mapGetters("meetingStore", ["meetingsAreLoading"]),
    ...mapGetters("memberStore", ["isApplicant"]),
    meetingTypeOptions() {
      return parseObjectToOptions(meetingTypes, "Alla typer");
    },
    isNewMeeting() {
      return this.$route.params.id === "new-item";
    }
  },
  methods: {
    ...mapActions("meetingStore", [
      "getMeeting",
      "editMeeting",
      "submitMeeting"
    ]),
    parseDate() {
      return this.meeting.date
        ? moment(this.meeting.date).toDate()
        : moment().toDate();
    },
    updateMeeting(field, value) {
      let formInput = {
        field: field,
        value: value
      };
      if (field === "date") {
        formInput.value = formatDate(value);
      }
      this.editMeeting(formInput);
    },
    submitEditedMeeting() {
      this.submitMeeting().then(() => {
        this.$router.push("/meetings");
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.Meeting-editor {
  @extend %text-S-subtle;
  font-weight: $font-bold;
  margin: $spacing-L 0;

  &__header {
    @extend %title-XL;
    margin: $spacing-L 0;
  }
}
</style>
